"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../../classnames"));
var Icon_1 = __importDefault(require("../Icon"));
var ButtonIcon = function (_a) {
    var icon = _a.icon, loading = _a.loading;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Icon_1.default, { icon: (loading ? "load-c" : icon) }),
        " "));
};
var Button = react_1.default.forwardRef(function (_a, ref) {
    var _b = _a.as, Element = _b === void 0 ? "button" : _b, children = _a.children, className = _a.className, _c = _a.type, type = _c === void 0 ? "button" : _c, icon = _a.icon, _d = _a.fillParent, fillParent = _d === void 0 ? false : _d, _e = _a.inverted, inverted = _e === void 0 ? false : _e, _f = _a.primary, primary = _f === void 0 ? false : _f, _g = _a.small, small = _g === void 0 ? false : _g, _h = _a.loading, loading = _h === void 0 ? false : _h, _j = _a.danger, danger = _j === void 0 ? false : _j, props = __rest(_a, ["as", "children", "className", "type", "icon", "fillParent", "inverted", "primary", "small", "loading", "danger"]);
    var buttonProps = __assign(__assign({}, props), { className: classnames_1.default("chq-btn", className, {
            "chq-btn-fp": fillParent,
            "chq-btn-iv": inverted,
            "chq-btn-pr": primary,
            "chq-btn-sm": small,
            "chq-btn-ld": loading,
            "chq-btn-dg": danger
        }) });
    if (Element === "button") {
        buttonProps.type = type;
    }
    return (react_1.default.createElement(Element, __assign({}, buttonProps, { ref: ref }),
        (loading || icon) && react_1.default.createElement(ButtonIcon, { icon: icon, loading: loading }),
        children));
});
exports.default = Button;
